import { Injectable } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IAppState } from '../index.state';

import { history$ } from './circuit-history.reducer';

@Injectable({
  providedIn: 'root'
})
export class CircuitHistoryFacade {
  readonly canUndo$: Observable<boolean> = history$.pipe(
    map(history => !!history.past.length));

  readonly canRedo$: Observable<boolean> = history$.pipe(
    map(history => !!history.future.length));

  constructor(private store: Store<IAppState>) { }

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

}
